// Roguelite mode constants
export const ROGUELITE = {
  // Zone boundaries (Y thresholds — world descends from 8000 to 0)
  ZONE_BOUNDARIES: [7600, 6800, 6000, 5200, 4400, 3600, 2800, 2000] as readonly number[],
  // Dormancy — enemy activation range (px vertical distance from human)
  ACTIVATION_RANGE: 1500,
  // Void pause duration during card draw (seconds)
  VOID_PAUSE_DURATION: 5.0,
  // Checkpoint platforms
  CHECKPOINT_PLATFORM_WIDTH: 600,
  CHECKPOINT_GLOW_COLOR: 0x44ff88,
  CHECKPOINT_PROXIMITY: 50,   // px proximity to trigger card draw
  // Card draw rarity weights
  DRAW_WEIGHT_COMMON: 50,
  DRAW_WEIGHT_UNCOMMON: 30,
  DRAW_WEIGHT_RARE: 15,
  DRAW_WEIGHT_EPIC: 5,
  // Pity system
  PITY_THRESHOLD: 2,
  // Phase 1: zones 1-4
  ZONE_ENEMIES: [1, 1, 2, 3] as readonly number[],
  ZONE_DRAW_TYPE: ['weapon1', 'weapon2', 'modifier', 'modifier'] as readonly string[],
  ZONE_AI_DIFFICULTY: [3, 4, 5, 5] as readonly number[],
  // Shot 2 momentum cost
  SHOT_2_MOMENTUM_COST: 80,
  // Card draw UI
  CARD_COUNT: 3,
} as const;
